import SearchIcon from "@mui/icons-material/Search";
import {
  CircularProgress,
  FormControl,
  InputAdornment,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

const SelectInput = ({
  name,
  label,
  value,
  handleChange,
  handleBlur,
  handleFocus,
  error,
  options,
  helperText,
  bg = "white",
  required,
  className,
  handleSearch,
  searchLoading,
  loading,
}) => {
  const ITEM_HEIGHT = 55;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        // width: 250,
      },
    },
  };

  return (
    <FormControl
      // hiddenLabel
      required={required}
      className="w-full"
      {...{ error, className }}
    >
      <InputLabel
        sx={{ bg: "white" }}
        id={name + "-label"}
        htmlFor={name + "-label"}
      >
        {label}
      </InputLabel>
      <Select
        labelId={name + "-label"}
        id={name}
        value={value}
        name={name}
        label={name}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        required={required}
        MenuProps={MenuProps}
        sx={{ background: bg }}
        // {...{...others}}
      >
        {handleSearch && (
          <ListSubheader>
            <TextField
              size="small"
              autoFocus
              placeholder="Type to search..."
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: searchLoading && (
                  <React.Fragment>
                    <CircularProgress color="inherit" size={20} />
                    {/* {params.InputProps.endAdornment} */}
                  </React.Fragment>
                ),
              }}
              onChange={handleSearch}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
        )}

        {loading ? (
          <p style={{ fontWeight: 500, padding: "0 1em", width: "100%" }}>
            Loading...
          </p>
        ) : (
          options?.map((data, key) => {
            if (data instanceof Object)
              return (
                <MenuItem {...{ value: data, key }}> {data?.value} </MenuItem>
              );
            else return <MenuItem {...{ value: data, key }}> {data} </MenuItem>;
          })
        )}
      </Select>
      {error && (
        <Typography
          className="bg-white pt-1 text-[0.75rem] px-[14px] leading-[1.66] font-normal"
          color="error"
        >
          {helperText || ""}
        </Typography>
      )}
    </FormControl>
  );
};

export default SelectInput;
